export const FontWeight400 = 400
export const FontWeight500 = 500
export const FontWeight600 = 600
export const FontWeight700 = 700
export const FontWeight900 = 900
